export const EGIFTCARD_REDEEM_REQUEST = 'EGIFTCARD_REDEEM_REQUEST'
export const EGIFTCARD_REDEEM_SUCCESS = 'EGIFTCARD_REDEEM_SUCCESS'
export const EGIFTCARD_REDEEM_FALIURE = 'EGIFTCARD_REDEEM_FALIURE'
export const EGIFTCARD_BALANCE_REQUEST = 'EGIFTCARD_BALANCE_REQUEST'
export const EGIFTCARD_BALANCE_SUCCESS = 'EGIFTCARD_BALANCE_SUCCESS'
export const EGIFTCARD_BALANCE_FALIURE = 'EGIFTCARD_BALANCE_FALIURE'
